import React from 'react';
import Image from '../Image';
import parse from 'html-react-parser';
import {currentLang, recipeURL} from '../../../utils/functions';
import { useTranslation } from 'react-i18next';
import W from '../Word';


const RecipeItem = ({detail}) => {
    const {t} = useTranslation();
    const url = recipeURL(detail.slug);
    return (
        <div className="list__item">
            {detail &&
            <div className="list__body">
                <div className="list__image">
                    <a className="read-more" href={url}><Image src={detail.image_url} /></a>
                    <div className="list__info">
                        <div className="badge">
                            {detail.cook_time && <div className="badge__item location"> <span className="icon-time"></span> {detail.cook_time} </div> }
                            {detail.calories && <div className="badge__item location"> <span className="icon-calories"></span> {detail.calories} </div>}
                        </div>
                    </div>
                </div>
                <div className="list__description">
                    <div>
                        <h3 className="title"> <a className="text--white" href={url}>{detail.title}</a> </h3>
                        <p className="excerpt text--white">
                            {detail.body && parse(detail.body)}
                        </p>
                    </div>
                    <a className="read-more" href={url}><W>recipes.view</W></a>
                </div>
            </div>
            }
        </div>
    )
}

export default RecipeItem
